
































































import BaseComponent from '@/components/base-component.vue';
import { dateFormat, getServerISODate } from '@/helpers/dateFormat';
import { TentativaContatoParmDTO } from '@/interfaces/pending-prescriptions';
import { listPendingPrescriptionStatusEdit, savePendingPrescriptionContact } from '@/services/pending-prescriptions';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import UiDatePicker from '../UI/date-picker.vue';

@Component({
  components: {
    UiDatePicker
  }
})
export default class PendingPrescriptionRegisterModal extends BaseComponent {
  @Prop()
  public id;

  dialogFlag = false;

  statusListLoading = false;
  statusList = [];
  statusSelec = null;
  dataFim = null;
  justificativa = null;
  ticket = null;
  dataMin = getServerISODate();

  parm: any = {};

  public form: any = {
    valid: false,
    rules: {
      status: [(v) => v != null || 'Informe o novo status'],
      dataFim: [
        (v) => {
          if (!v) return 'Informe a data fim';
          else return true;
        }
      ],
      justificativa: [(v) => (v != null && v.length > 0) || 'Informe a observação/justificativa']
    }
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  loading = false;
  error = false;
  items = null;

  mounted() {
    this.loadStatusList();
    setTimeout(() => {
      this.dialogFlag = true;
    }, 10);

    setTimeout(() => {
      //this.$refs['status'].focus();
    }, 200);
  }

  loadStatusList() {
    this.statusListLoading = true;
    listPendingPrescriptionStatusEdit().subscribe(
      (res) => {
        this.statusListLoading = false;
        this.statusList = res;
      },
      (error) => {
        this.statusListLoading = false;
        this.showToastApiError(error);
      }
    );
  }

  closeForm() {
    this.$emit('close');
  }

  salvar() {
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }

    this.loader.start('Salvando registro...');
    let parm = new TentativaContatoParmDTO();
    parm.id = this.id;
    parm.dataFimStatus = this.dataFim ? dateFormat(this.dataFim, 'ISO-DATE') : null;
    parm.justificativa = this.justificativa;
    parm.status = this.statusSelec.id;
    parm.ticketZendesk = this.ticket;

    savePendingPrescriptionContact(parm).subscribe(
      (res) => {
        this.loader.stop();
        this.$emit('save');
      },
      (error) => {
        this.loader.stop();
        this.showToastApiError(error);
      }
    );
  }
}
